module.exports = __webpack_public_path__ + "img/ZA.b2f370d4.svg";